import { useState, useEffect } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { useDataFetch } from "../../Hooks/Use-data-fetch";

export const UserDeliverySection = ({
  setSelectedUser,
  paymentMethod,
  setPaymentMethod,
  deliveryType,
  setDeliveryType,
  currency,
  setCurrency,
  createdAt,
  setCreatedAt,
}) => {
  const { getData } = useDataFetch();
  const [searchTerm, setSearchTerm] = useState("");
  const [finalSearch, setFinalSearch] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFinalSearch(searchTerm.trim());
    }, 600);
    return () => clearTimeout(timeout);
  }, [searchTerm]);

  const { data: usersData, isPending: loadingUsers } = getData(
    ["users", finalSearch],
    "/users/all",
    { enabled: finalSearch.length >= 3 },
    { search: finalSearch }
  );

  const users = usersData?.data?.users || [];

  const mappedOptions = users.map((user) => ({
    value: user.id,
    label: user.document
      ? `${user.multyhealth_code} - ${user.document} - ${user.name}`
      : `${user.multyhealth_code} - ${user.name}`,
    user,
  }));


  const options =
    finalSearch.length >= 3
      ? mappedOptions
      : selectedOption
      ? [selectedOption]
      : [];


  const handleChange = (option) => {
    setSelectedOption(option || null);
    
    setSelectedUser(option ? option : null);
    setSearchTerm("");
    setFinalSearch("");
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <Row className="mb-3">
          <Col md={4}>
            <Form.Label>Cliente</Form.Label>
            <Select
              value={selectedOption}
              options={options}
              getOptionValue={(opt) => opt.value} 
              getOptionLabel={(opt) => opt.label}
              onChange={handleChange}
              onInputChange={(val, { action }) => {
                if (action === "input-change") setSearchTerm(val);
              }}
              inputValue={searchTerm}
              placeholder="Buscar por código, cédula o nombre"
              isClearable
              isLoading={finalSearch.length >= 3 && loadingUsers}
              noOptionsMessage={() =>
                searchTerm.length < 3
                  ? "Escribe al menos 3 caracteres"
                  : "No se encontraron usuarios"
              }
            />
          </Col>

          <Col md={4}>
            <Form.Label>Método de pago</Form.Label>
            <Form.Select
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <option value="">Selecciona</option>
              <option value="CASH">Efectivo</option>
              <option value="TRANSFER">Transferencia</option>
              <option value="LINK">Link de pago</option>
            </Form.Select>
          </Col>

          <Col md={4}>
            <Form.Label>Tipo de entrega</Form.Label>
            <Form.Select
              onChange={(e) => setDeliveryType(e.target.value)}
              value={deliveryType}
            >
              <option value="">Selecciona</option>
              <option value="PHYSICAL">Física</option>
              <option value="DELIVERY">Domicilio</option>
            </Form.Select>
          </Col>

          <Col md={4} className="mt-3">
            <Form.Group className="mb-3" controlId="currencySelector">
              <Form.Label>Moneda</Form.Label>
              <Form.Select
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
              >
                <option value="COP">COP - Peso colombiano</option>
                <option value="USDT">USDT - Tether</option>
                <option value="EUR">EUR - Euro</option>
              </Form.Select>
            </Form.Group>
          </Col>
          
          <Col md={4} className="mt-3">
            <Form.Group>
              <Form.Label>Fecha de creación</Form.Label>
              <Form.Control
                type="datetime-local"
                value={createdAt}
                onChange={(e) => setCreatedAt(e.target.value)}
              />
            </Form.Group>
          </Col>

        </Row>
      </CardBody>
    </Card>
  );
};
